import { styled } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const MediaItemListContainer = styled('div')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(1, 1fr)',
  gap: 20,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'repeat(2, 1fr)',
  },

  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(3, 1fr)',
  },
  [theme.breakpoints.up(1650)]: {
    gridTemplateColumns: 'repeat(4, 1fr)',
  },
}));

export const MediaItemWrapper = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? COLORS.DARK_BLUE_GRAY : COLORS.LIGHT_BORDER,
  border: theme.palette.type === 'dark' ? `unset` : `1px solid ${COLORS.LIGHT_BORDER}`,
  height: 62,
  width: '100%',
  position: 'relative',
  cursor: 'pointer',
  borderRadius: 8,
  display: 'grid',
  alignItems: 'center',
  gridTemplateColumns: 'auto 1fr auto',
  gap: 15,
  padding: '5px 15px',
}));
